import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {TYPE_ADGROUP, TYPE_CAMPAIGN} from "../DashboardRow";

const STATUS_VARIANT = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    ARCHIVED: 'archived',
    REMOVED: 'removed',
    UNKNOWN: 'unknown',
};

class CampaignStatusBadgeCellClass extends Component {
    render() {
        const {status, rowType, t} = this.props;

        // Vacío para BU/BUCC por diseño.
        if (rowType !== TYPE_CAMPAIGN && rowType !== TYPE_ADGROUP) {
            return <td className="single-data" />;
        }

        if (!status) {
            return <td className="single-data" />;
        }

        const variant = STATUS_VARIANT[status] || STATUS_VARIANT.UNKNOWN;
        const labelKey = `dashboard.status_badge.${variant}`;

        return (
            <td className="single-data">
                <span className={`status-badge -${variant}`}>
                    <span className="status-badge-dot" />
                    <span className="status-badge-label">{t(labelKey)}</span>
                </span>
            </td>
        );
    }
}

CampaignStatusBadgeCellClass.defaultProps = {
    status: null,
};

export const CampaignStatusBadgeCell = withTranslation()(CampaignStatusBadgeCellClass);
